module.exports = __webpack_public_path__ + "static/media/NightsStay.b3e9e73c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/NightsStay.svg
// module id = 560
// module chunks = 0